import { render } from "./FlowInsights.vue?vue&type=template&id=8605324e&scoped=true"
import script from "./FlowInsights.vue?vue&type=script&lang=js"
export * from "./FlowInsights.vue?vue&type=script&lang=js"

import "./FlowInsights.vue?vue&type=style&index=0&id=8605324e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8605324e"],['__file',"src/components/FlowInsights.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8605324e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8605324e', __exports__)) {
    api.reload('8605324e', __exports__)
  }
  
  module.hot.accept("./FlowInsights.vue?vue&type=template&id=8605324e&scoped=true", () => {
    api.rerender('8605324e', render)
  })

}


export default __exports__